// Schedule and Tenders: where they sit in the main app (their code is in src/modules/)
import { h, useEffect, useRef } from '../core/react.js';
import { T } from '../core/theme.js';
import { moduleElement, startModule } from '../../modules/mount.js';

export const MODULES = {
  schedule: { title: 'On-site schedules' },
  tenders: { title: 'Tenders' }
};
// One area per module opened so far; only the current page's is shown. The module's own element is kept between
// redraws (and if the main app redraws from scratch), so it never restarts.
function ModuleArea({ id, shown }) {
  const box = useRef(null);
  useEffect(() => {
    box.current.appendChild(moduleElement(id));
    startModule(id).catch(() => {});
  }, [id]);
  return h("div", { ref: box, title: MODULES[id].title, style: { flex: 1, minHeight: 0, display: shown ? 'block' : 'none' } });
}
export function ModuleAreas({ view, opened }) {
  const shown = MODULES[view];
  return h("div", {
    style: { flex: 1, display: shown ? 'flex' : 'none', flexDirection: 'column', overflow: 'hidden', background: T.white }
  }, Object.keys(MODULES).filter(id => opened.includes(id)).map(id => h(ModuleArea, { key: id, id, shown: view === id })));
}
